module.exports = __webpack_public_path__ + "static/media/streetSigns.8eeffab9.jpg";